<template>
  <b-dropdown :triggers="['hover']" aria-role="list" position="is-bottom-left">
    <template #trigger>
      <button
        class="button"
        :class="{
          'is-success': invoice && invoice.status === 'emitted',
          'is-danger':
            invoice &&
            [
              'rejected',
              'error',
              'ncm-missing',
              'nf-serie-not-configured'
            ].includes(invoice.status),
          'is-dark':
            invoice && ['cancelled', 'unusedNumber'].includes(invoice.status),
          'is-warning': invoice && invoice.status === 'pending'
        }"
        :disabled="
          invoice && ['notSent', 'notEnabled'].includes(invoice.status)
        "
        slot="trigger"
      >
        {{
          invoice.status === "notSent"
            ? "Não enviada"
            : invoice.status === "emitted"
            ? "Emitida"
            : invoice.status === "rejected"
            ? "Rejeitada"
            : invoice.status === "pending"
            ? "Pendente"
            : invoice.status === "error"
            ? "Erro"
            : invoice.status === "cancelled"
            ? "Cancelada"
            : invoice.status === "notEnabled"
            ? "Não habilitada"
            : invoice.status === "ncm-missing"
            ? "Faltando NCM"
            : invoice.status === "nf-serie-not-configured"
            ? "Faltando número de série"
            : invoice.status === "unusedNumber"
            ? "Inutilizada"
            : "-"
        }}
      </button>
    </template>

    <b-dropdown-item
      @click="copyContent(sefazMessage, 'Mensagem do emissor copiada!')"
      aria-role="listitem"
      class="error-card"
      style="text-wrap: pretty;"
    >
      <b-tooltip position="is-left" type="is-danger" multilined>
        <template #content>
          <span style="white-space: pre-line; font-size: 0.8rem;">
            {{ sefazMessageProducts }}
          </span>
        </template>

        <b>Mensagem do Emissor: </b>
        <br />
        <span style="white-space: pre-line;font-size: 0.8rem;">{{
          sefazMessage
        }}</span>
        <b-icon icon="copy"></b-icon>
      </b-tooltip>
    </b-dropdown-item>

    <b-dropdown-item
      @click="copyContent(transactionId, 'ID da transação copiado!')"
      aria-role="listitem"
    >
      <b>Transaction ID: </b>{{ transactionId }}
      <b-icon icon="copy"></b-icon>
    </b-dropdown-item>

    <b-dropdown-item
      @click="copyContent(invoice.uuid, 'UUID copiado!')"
      aria-role="listitem"
    >
      <b>UUID: </b>{{ invoice.uuid }}
      <b-icon icon="copy"></b-icon>
    </b-dropdown-item>

    <b-dropdown-item
      v-if="merchantReference"
      @click="copyContent(merchantReference, 'Texto copiado!')"
      aria-role="listitem"
    >
      <b>Adyen: </b>{{ merchantReference }}
      <b-icon icon="copy"></b-icon>
    </b-dropdown-item>

    <b-dropdown-item
      v-if="invoice.nfSerie && invoice.nfNumber"
      aria-role="listitem"
      @click="
        copyContent(
          `Nº ${invoice.nfNumber} | Série ${invoice.nfSerie}`,
          'NF copiada!'
        )
      "
    >
      <b>{{ invoiceType }}: </b
      >{{ `Nº ${invoice.nfNumber} | Série ${invoice.nfSerie}` }}
      <b-icon icon="copy"></b-icon>
    </b-dropdown-item>

    <b-dropdown-item>
      <b-button
        v-if="invoice.status === 'emitted'"
        @click="$emit('download-nf', { transactionId, type: 'xml' })"
        type="is-success"
        >Download XML</b-button
      >

      <b-button
        v-if="invoice.status === 'emitted'"
        style="margin-left: 10px"
        @click="$emit('download-nf', { transactionId, type: 'pdf' })"
        type="is-success"
        >Download PDF</b-button
      >
    </b-dropdown-item>
  </b-dropdown>
</template>

<script>
import { common } from "../../../mixins/common";

export default {
  mixins: [common],

  props: [
    "invoice",
    "transactionId",
    "merchantReference",
    "status",
    "cartItems"
  ],

  methods: {},

  computed: {
    invoiceType() {
      if (this.invoice) {
        if (this.invoice.invoiceType === "55") return "NF";
        else return "Cupom Fiscal";
      }

      return "";
    },

    sefazMessage() {
      if (this.invoice.status !== "error") return "-";

      if (this.invoice.tecnospeed && this.invoice.tecnospeed.error) {
        return this.invoice.tecnospeed.error;
      }

      if (this.invoice.error) {
        return this.invoice.error;
      }

      return "-";
    },

    sefazMessageProducts() {
      if (this.invoice.error) {
        let message = "";
        for (const item of this.cartItems) {
          if (this.invoice.error.includes(item.barcode)) {
            message += `${item.barcode} - ${item.name}\n`;
          }
        }

        return message;
      }

      return "-";
    }
  }
};
</script>

<style scoped>
.error-card {
  background-color: #d7d7d7;
  color: #000000;
  padding: 10px;
  border-radius: 5px;
  margin-top: 10px;
}
</style>
